import { cn } from '@/utils/cn';
import { DocumentCategory } from '../types';
import { CATEGORY_ICONS } from '../constants';
import { getCategoryLabel } from '../utils';

interface DocumentCategoryBadgeProps {
  category: DocumentCategory;
  size?: 'sm' | 'md';
}

export const DocumentCategoryBadge: React.FC<DocumentCategoryBadgeProps> = ({
  category,
  size = 'md',
}) => {
  const icon = CATEGORY_ICONS[category];
  const label = getCategoryLabel(category);

  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-3 py-1',
  };

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-lg bg-primary-50 text-primary-700 font-medium',
        sizeClasses[size]
      )}
    >
      <span>{icon}</span>
      <span>{label}</span>
    </span>
  );
};

